import { JSX } from 'react';
import classNames from 'classnames';
import { IconDirection } from './enums/IconDirection';
import { ChevronIcon } from '../Icons';
import classes from './DirectionalIcon.module.scss';

interface IProps {
    icon?: IIconComponent;
    direction: IconDirection;
    className?: string;
    dataQa?: string;
}

export const DirectionalIcon = (props: IProps): JSX.Element => {
    const Icon = props.icon || ChevronIcon;

    return (
        <span className={classNames(classes.container, props.className)} data-qa={props.dataQa}>
            <Icon className={classNames(classes.icon, classes[props.direction])} />
        </span>
    );
};
